import { render, staticRenderFns } from "./VideoAdder.vue?vue&type=template&id=4a58383a&scoped=true"
import script from "./VideoAdder.vue?vue&type=script&lang=js"
export * from "./VideoAdder.vue?vue&type=script&lang=js"
import style0 from "./VideoAdder.vue?vue&type=style&index=0&id=4a58383a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58383a",
  null
  
)

export default component.exports